import { render, staticRenderFns } from "./PublishDetail.vue?vue&type=template&id=4bf0927e&"
import script from "./PublishDetail.vue?vue&type=script&lang=ts&"
export * from "./PublishDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports